import { render, staticRenderFns } from "./historyTable.vue?vue&type=template&id=3b5b4338"
import script from "./historyTable.vue?vue&type=script&lang=js"
export * from "./historyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports